import Friend from './index';

export default { path: '/home/friend', component: Friend };
